import { render } from "./ModalConfigurarGrupos.vue?vue&type=template&id=534b9f24&scoped=true"
import script from "./ModalConfigurarGrupos.vue?vue&type=script&lang=js"
export * from "./ModalConfigurarGrupos.vue?vue&type=script&lang=js"

import "./ModalConfigurarGrupos.vue?vue&type=style&index=0&id=534b9f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534b9f24"]])

export default __exports__